import * as z from 'zod';

import { booleanFormSchema } from '@/_schemas/generic';

import { paymentMethodFieldFormRowSchema } from './payment-method-field-query-schema';
import { paymentMethodQuerySchema } from './payment-method-query-schema';

export const paymentMethodFormSchema = paymentMethodQuerySchema.extend({
  name: z.string().min(3),
  is_active: booleanFormSchema(),
  include_for_taking_tender: booleanFormSchema(),
  include_for_manual_deposit: booleanFormSchema(),
  payment_method_fields: z.array(paymentMethodFieldFormRowSchema),
});

export type PaymentMethodFormSchema = z.infer<typeof paymentMethodFormSchema>;
